module.exports = __webpack_public_path__ + "media/images/icons/check-d0dffb0c3e6ef9f01cae3f13cfa4a3e2.svg";